<template>
  <div class="LoginDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      custom-class="login_dialog"
      :before-close="handleClose"
    >
      <div class="login_title">登录青叶智能</div>
      <div class="login_tabs">
        <span
          v-for="tab in loginTabs"
          :key="tab.key"
          class="login_tab"
          :class="{ active: loginType === tab.key }"
          @click="switchType(tab.key)"
        >{{ tab.label }}</span>
      </div>
      <el-form :model="form" :rules="rules" ref="loginForm" label-position="top">
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            maxlength="11"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="loginType === 'password'" label="密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="loginType === 'code'" label="验证码" prop="code">
          <div class="code_row">
            <el-input
              v-model="form.code"
              placeholder="请输入验证码"
              maxlength="6"
              @keyup.enter.native="handleLogin"
            ></el-input>
            <el-button
              class="code_btn"
              :disabled="countdown > 0"
              @click="sendCode"
            >{{ countdown > 0 ? countdown + "s后重发" : "获取验证码" }}</el-button>
          </div>
        </el-form-item>
        <el-button class="login_btn" :loading="loading" @click="handleLogin">登 录</el-button>
      </el-form>
      <div class="login_register">
        还没有账号？
        <span class="login_register_link" @click="handleRegister">立即注册</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LoginDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (/^1[3-9]\d{9}$/.test(value)) {
        return callback();
      }
      callback("请输入正确的手机号");
    };
    return {
      loading: false,
      loginType: "password",
      loginTabs: [
        { key: "password", label: "密码登录" },
        { key: "code", label: "验证码登录" },
      ],
      countdown: 0,
      timer: null,
      sentCode: "",
      form: {
        phone: "",
        password: "",
        code: "",
      },
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码为6位数字", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    //登录成功后清空表单和校验状态
    resetForm() {
      this.form.phone = "";
      this.form.password = "";
      this.form.code = "";
      this.sentCode = "";
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate();
      });
    },
    //切换登录方式
    switchType(key) {
      this.loginType = key;
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate();
      });
    },
    sendCode() {
      this.$refs.loginForm.validateField("phone", (errMsg) => {
        if (errMsg) return;
        this.$store.dispatch("auth/sendCode", { phone: this.form.phone, scene: "login" }).then((data) => {
          this.$message.success(data && data.smsCode ? "验证码已发送：" + data.smsCode : "验证码已发送");
          this.countdown = 60;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) clearInterval(this.timer);
          }, 1000);
        }).catch((err) => {
          this.$message.error((err && err.msg) || "验证码发送失败");
        });
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$store.dispatch("auth/login", {
          phone: this.form.phone,
          password: this.form.password,
          code: this.form.code,
          loginType: this.loginType,
        }).then(() => {
          this.loading = false;
          this.$message.success("登录成功");
          this.$emit("success");
          this.handleClose();
          this.resetForm();
        }).catch((err) => {
          this.loading = false;
          this.$message.error((err && err.msg) || "登录失败");
        });
      });
    },
    handleRegister() {
      this.$emit("register");
      this.handleClose();
    },
  },
};
</script>

<style scoped>
.LoginDialog >>> .login_dialog {
  border-radius: 8px;
}

.LoginDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.LoginDialog >>> .login_dialog {
  margin: 0 !important;
}

.LoginDialog >>> .login_dialog .el-dialog__header {
  padding: 0;
}

.LoginDialog >>> .login_dialog .el-dialog__body {
  padding: 28px 32px 20px;
}

.login_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.login_tabs {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding-bottom: 16px;
}

.login_tab {
  font-size: 14px;
  color: #999999;
  cursor: pointer;
  padding-bottom: 4px;
}

.login_tab.active {
  color: #1b63a7;
  font-weight: 600;
  border-bottom: 2px solid #1b63a7;
}

.LoginDialog >>> .el-form-item {
  margin-bottom: 18px;
}

.LoginDialog >>> .el-form--label-top .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
}

.code_row {
  display: flex;
  gap: 10px;
}

.code_row .el-input {
  flex: 1;
}

.code_btn {
  flex-shrink: 0;
  height: 40px;
  background: #1b63a7;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0 14px;
  font-size: 13px;
}

.code_btn:hover {
  background: #2968bd;
  border-color: #2968bd;
}

.code_btn.is-disabled {
  background: #a0cfff;
  border-color: #a0cfff;
  color: #fff;
}

.login_btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
  margin-top: 4px;
}

.login_btn:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}

.login_register {
  text-align: center;
  font-size: 13px;
  color: #999999;
  padding-top: 16px;
}

.login_register_link {
  color: #2968bd;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/components/LoginDialog.vue